// Module
var code = "<div class=\"page-x-error-404\"> <h1>404</h1> <h2>Not found !</h2> </div> ";
// Exports
module.exports = code;